'use es6';

import I18n from 'I18n';
import ThreadHistory from '../records/ThreadHistory';
import { buildInitialMessage } from '../../initial-message/operators/buildInitialMessage';
import { buildCommonMessage } from '../../common-message-format/operators/buildCommonMessage';
import { buildSender } from '../../common-message-format/operators/buildSender';
import OfficeHoursMessage from '../../office-hours-message/records/OfficeHoursMessage';
import TypicalResponseTimeMessage from '../../typical-response-time/records/TypicalResponseTimeMessage';
import EmailCapturePromptMessage from '../../email-capture-prompt/records/EmailCapturePromptMessage';
export function getMockMessages({
  firstMessage,
  includeVisitorReply,
  officeHoursMessageText,
  replyTimeMessageText,
  emailCapturePromptMessageText
}) {
  const text = !firstMessage ? I18n.text('conversations-message-history.default.repText') : firstMessage;
  const VISITOR_SENDER_ID = 'VISITOR_ID';
  const messages = [buildInitialMessage({
    text,
    timestamp: I18n.moment().valueOf()
  })];
  if (includeVisitorReply) {
    const sender = buildSender({
      senderId: VISITOR_SENDER_ID
    });
    messages.push(buildCommonMessage({
      text: I18n.text('conversations-message-history.default.visitorText'),
      timestamp: I18n.moment().add(1, 'millisecond').valueOf()
    }).set('sender', sender));
  }
  if (officeHoursMessageText) {
    messages.push(OfficeHoursMessage({
      text: officeHoursMessageText,
      timestamp: I18n.moment().add(2, 'millisecond').valueOf()
    }));
  }
  if (replyTimeMessageText) {
    messages.push(TypicalResponseTimeMessage({
      text: replyTimeMessageText,
      timestamp: I18n.moment().add(3, 'millisecond').valueOf()
    }));
  }
  if (emailCapturePromptMessageText) {
    messages.push(EmailCapturePromptMessage({
      text: emailCapturePromptMessageText,
      timestamp: I18n.moment().add(4, 'millisecond').valueOf()
    }));
  }
  return messages;
}
export function getMockThreadHistory({
  firstMessage,
  includeVisitorReply,
  officeHoursMessageText,
  replyTimeMessageText,
  emailCapturePromptMessageText
}) {
  if (typeof includeVisitorReply === 'undefined') {
    includeVisitorReply = true;
  }
  return new ThreadHistory({
    messages: {
      results: getMockMessages({
        firstMessage,
        includeVisitorReply,
        officeHoursMessageText,
        replyTimeMessageText,
        emailCapturePromptMessageText
      }),
      hasMore: false
    }
  });
}